export enum FormatterType {
  Integer = 'Integer',
  Decimal = 'Decimal',
  Percentage = 'Percentage',
  Currency = 'Currency',
  YesOrNo = 'YesOrNo',
  Date = 'Date',
}
